/**
 * Logger utility that only logs in development mode
 * Prevents sensitive information from being exposed in production
 */

const isDev = import.meta.env.DEV;

export const logger = {
    /**
     * Log general messages (development only)
     */
    log: (...args: unknown[]): void => {
        if (isDev) {
            console.log('[LOG]', ...args);
        }
    },

    /**
     * Log errors (always logged, even in production)
     */
    error: (...args: unknown[]): void => {
        console.error('[ERROR]', ...args);
    },

    /**
     * Log warnings (development only)
     */
    warn: (...args: unknown[]): void => {
        if (isDev) {
            console.warn('[WARN]', ...args);
        }
    },

    /**
     * Log info messages (development only)
     */
    info: (...args: unknown[]): void => {
        if (isDev) {
            console.info('[INFO]', ...args);
        }
    },

    /**
     * Log debug messages with detailed context (development only)
     */
    debug: (context: string, data?: unknown): void => {
        if (isDev) {
            console.log(`[DEBUG] ${context}:`, data);
        }
    },
};

export default logger;
